import { useSearchParams } from "@remix-run/react";
import { useMemo } from "react";
import type { Language } from "./index";
import { t as translate } from "./index";

export function useI18n() {
  const [searchParams, setSearchParams] = useSearchParams();
  const lang = (searchParams.get("lang") || "ar") as Language;

  const setLanguage = (newLang: Language) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("lang", newLang);
    setSearchParams(newParams, { replace: true });
  };

  const t = useMemo(
    () => (key: string, params?: Record<string, string>) => translate(lang, key, params),
    [lang],
  );

  const isRTL = lang === "ar";

  return {
    lang,
    t,
    setLanguage,
    isRTL,
  };
}

